import React, { useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckIcon from "@mui/icons-material/Check";
import Modal from "./Modal";
import "./DownloadChartModal.css";

export interface DownloadChartOptions {
  format: "jpeg" | "pdf";
  includeLabels: boolean;
}

interface DownloadChartModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (options: DownloadChartOptions) => void;
  isDownloading: boolean;
}

const DownloadChartModal: React.FC<DownloadChartModalProps> = ({
  isOpen,
  onClose,
  onDownload,
  isDownloading,
}) => {
  const [format, setFormat] = useState<"jpeg" | "pdf">("jpeg");
  const [includeLabels, setIncludeLabels] = useState(true);

  const handleDownload = () => {
    onDownload({ format, includeLabels });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Download chart"
      maxWidth="420px"
    >
      <div className="dcm-body">
        <div className="dcm-section">
          <label className="dcm-label">Format</label>
          <div className="dcm-format-toggle">
            <button
              className={`dcm-format-btn ${format === "jpeg" ? "dcm-format-btn--active" : ""}`}
              onClick={() => setFormat("jpeg")}
            >
              JPEG
            </button>
            <button
              className={`dcm-format-btn ${format === "pdf" ? "dcm-format-btn--active" : ""}`}
              onClick={() => setFormat("pdf")}
            >
              PDF
            </button>
          </div>
          <p className="dcm-helper-text">
            JPEG for sharing, PDF for print or presentation.
          </p>
        </div>

        <div className="dcm-section">
          <label className="dcm-label">Options</label>
          <label className="dcm-checkbox-row">
            <div
              className={`dcm-custom-checkbox ${includeLabels ? "dcm-custom-checkbox--checked" : ""}`}
              onClick={() => setIncludeLabels(!includeLabels)}
            >
              {includeLabels && (
                <CheckIcon style={{ fontSize: 13, color: "white" }} />
              )}
            </div>
            <div
              className="dcm-checkbox-text"
              onClick={() => setIncludeLabels(!includeLabels)}
            >
              <span className="dcm-checkbox-title">Include keyword labels</span>
              <span className="dcm-helper-text">
                Show keyword names on each bubble in the export.
              </span>
            </div>
          </label>
        </div>

        <div className="dcm-info-banner">
          <InfoOutlinedIcon className="dcm-info-icon" />
          <p>
            Export includes stat cards, bubble chart, legend, and footer. Domain
            and cluster name are shown at the top.
          </p>
        </div>

        <div className="dcm-footer">
          <button
            className="dcm-btn dcm-btn--cancel"
            onClick={onClose}
            disabled={isDownloading}
          >
            Cancel
          </button>
          <button
            className="dcm-btn dcm-btn--download"
            onClick={handleDownload}
            disabled={isDownloading}
          >
            <FileDownloadIcon style={{ fontSize: 18 }} />
            {isDownloading ? "Downloading..." : "Download"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadChartModal;
